export enum DescriptionWindowActionType {
    SHOW_DESCRIPTION_WINDOW = 'SHOW_DESCRIPTION_WINDOW',
    HIDE_DESCRIPTION_WINDOW= 'HIDE_DESCRIPTION_WINDOW',
    CHANGE_COORDINATES = 'CHANGE_COORDINATES',
    CHANGE_SIZE = 'CHANGE_SIZE',
    SET_DESCRIPTION_DATA = 'SET_DESCRIPTION_DATA',
}

export interface IDescriptionWindowState {
    show: boolean
    coordinates: { x: number, y: number }
    size: { width: number, height: number }
    data: {
        header: string
        description: string
    }
}